import { client } from '../http';

async function fetchInsights() {
  const response = await client.get('/api/insights/all');
  return response.data;
}

async function markAsRead(insightId, insightName, insight) {
  const response = await client.post('/api/read-insights', { insightName, insightId, insight });
  return response.data;
}

async function sendInsightFeedback(insightId, insightName, insight, feedback) {
  const response = await client.post('/api/create-insight-feedback-input', { insightId, insightName, insight, feedback });
  return response.data;
}

export default {
  fetchInsights,
  markAsRead,
  sendInsightFeedback,
};
